<template>
    <div class="analysis">
        <div class="box">
        <div class="analysisframe">
            <div class="analysisimg">
                <i class="iconfont icon-icon-book ifon"></i>
                <span>企业logo</span>
            </div>
            <div class="analysiscontent">
                <el-upload
                    :action="action"
                    :on-success="handleAvatarSuccess"
                    :show-file-list="false"
                    :headers="myHeader"
                     :on-error="onerror" 
                    list-type="picture-card"
                >
                    <template v-if="companyInfo.logo">
                        <img width="100%" height="100%" :src="companyInfo.logo" class="avatar" />
                    </template>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </div>
        </div>
        <div class="analysisframe">
            <div class="analysisimg">
                <i class="iconfont icon-icon-book ifon"></i>
                <span>企业信息</span>
            </div>
            <div class="analysiscontent">
                <!-- <i @click="edit" class="el-icon-edit-outline iedit"></i> -->
                <span>企业全称：{{ companyInfo.companyFullName }}</span>
                <span>企业简称：{{ companyInfo.chineseShortName }}</span>
                <span>企业地址：{{ companyInfo.companyAddress }}</span>
                <span>联系电话：{{ companyInfo.telephone }}</span>
            </div>
        </div>
        <div class="analysisframe">
            <div class="analysisimg">
                <i class="iconfont icon-renshutongji ifon"></i>
                <span>企业人数</span>
            </div>
            <div class="analysiscontent" v-if="this.UserInfo.type === 1">
                <span>企业成员：{{ companyInfo.companyMemberNumber }}人</span>
                <span>分公司数量：{{ companyInfo.baranchCompanyNumber }}</span>
                <span>子公司数量：{{ companyInfo.childCompanyNumber }}</span>
            </div>

            <div class="analysiscontent" v-if="this.UserInfo.type === 2">
                <span>企业成员：{{ companyInfo.companyMemberNumber }}人</span>
                <span>
                    子公司创建数量/创建数量上限：{{ companyInfo.childCompanyCount }}/{{ companyInfo.childCompanyMax }}
                </span>
                <span>
                    子公司运营员工数量/创建数量上限：{{ companyInfo.childCompanyMemberMax }}/{{
                        companyInfo.companyMemberMax
                    }}
                </span>
            </div>

            <div class="analysiscontent" v-if="this.UserInfo.type === 3">
                <span>企业成员：{{ companyInfo.companyMemberNumber }}人</span>
                <span>
                    运营员工数量/创建数量上限：{{ companyInfo.companyOperationMemberNumber }}/{{
                        companyInfo.companyMemberMax
                    }}
                </span>
            </div>
        </div>
        <div class="analysisframe">
            <div class="analysisimg">
                <i class="iconfont icon-yue ifon"></i>
                <span>余额</span>
            </div>
            <div class="analysiscontent">
                <!-- <span>公司余额：0元</span> -->
                <span>可用余额：{{ companyInfo.buckleBalance }}元</span>
                <span>实际余额：{{ companyInfo.balance }}元</span>
                <el-button type="danger" @click="immediately">立即充值</el-button>
            </div>
        </div>

        <div class="analysisframe" v-if="this.UserInfo.type == 3">
            <div class="Customer">
                <div class="analysisimg" style="display: flex;align-items: center;flex-wrap: wrap;">
                    <img src="../../assets/imags/客服经理.png" style="width:95px;" alt="">
                    <span>专属客服经理</span>
                </div>
                <div class="analysiscontent" style="line-height:18px;margin-left:10px;">
                    <p>客户经理：<label v-if="companyInfo.accountManager!=null">{{companyInfo.accountManager.roleUserName}}</label><label v-if="companyInfo.accountManager == null">暂无分配客服经理</label></p>
                    <p>联系方式：<label v-if="companyInfo.accountManager!=null">{{companyInfo.accountManager.phone}}</label></p>
                    <p>QQ：<label v-if="companyInfo.accountManager!=null">{{companyInfo.accountManager.qqr}}</label></p>
                    <p>服务时间：<label v-if="companyInfo.accountManager!=null">{{companyInfo.accountManager.servicePeriod}}</label></p>
                    <p>职责范围：<label v-if="companyInfo.accountManager!=null">{{companyInfo.accountManager.responsibilityRange}}</label></p>
                    <!-- <p class="responsibilities">
                        职责范围：
                        <el-popover
                                placement="bottom"
                                title="职责范围"
                                width="200"
                                trigger="click"
                                :content="companyInfo.accountManager.responsibilityRange">
                                <label slot="reference" v-if="companyInfo.accountManager!=null" class="clickView">点击查看职责范围</label>
                        </el-popover>
                    </p> -->
                </div>
                <div class="right">
                    <img :src="companyInfo.accountManager.qrCode" alt="" style="width:80px;height:80px;" v-if="companyInfo.accountManager!=null">
                </div>
            </div>
        </div>

        <div class="analysisframe" v-if="this.UserInfo.type == 3">
            <div class="Customer">
                <div class="analysisimg" style="display: flex;align-items: center;flex-wrap: wrap;">
                    <img src="../../assets/imags/客服经理.png" style="width:95px;" alt="">
                    <span>物流客服经理</span>
                </div>
                <div class="analysiscontent" style="line-height:18px;margin-left:10px;">
                    <p>客户经理：<label v-if="companyInfo.warehouseAccountManager!=null">{{companyInfo.warehouseAccountManager.roleUserName}}</label><label v-if="companyInfo.warehouseAccountManager == null">暂无分配客服经理</label></p>
                    <p>联系方式：<label v-if="companyInfo.warehouseAccountManager!=null">{{companyInfo.warehouseAccountManager.phone}}</label></p>
                    <p>QQ：<label v-if="companyInfo.warehouseAccountManager!=null">{{companyInfo.warehouseAccountManager.qqr}}</label></p>
                    <p>服务时间：<label v-if="companyInfo.warehouseAccountManager!=null">{{companyInfo.warehouseAccountManager.servicePeriod}}</label></p>
                    <p>职责范围：<label v-if="companyInfo.warehouseAccountManager!=null">{{companyInfo.warehouseAccountManager.responsibilityRange}}</label></p>
                    <!-- <p class="responsibilities">
                        职责范围：
                        <el-popover
                                placement="bottom"
                                title="职责范围"
                                width="200"
                                trigger="click"
                                :content="companyInfo.warehouseAccountManager.responsibilityRange">
                                <label slot="reference" v-if="companyInfo.warehouseAccountManager!=null" class="clickView">点击查看职责范围</label>
                        </el-popover>
                    </p> -->
                </div>
                <div class="right">
                    <img :src="companyInfo.warehouseAccountManager.qrCode" alt="" style="width:80px;height:80px;" v-if="companyInfo.warehouseAccountManager!=null">
                </div>
            </div>
        </div>
        </div>

        <div style="width:100%;margin-top:20px;" v-if="companyInfo.selfUseChannelSwitch == 1&&this.UserInfo.type !== 2">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <h2>渠道服务API</h2>
                    <el-button style="margin-top:15px;" type="primary" size="mini" @click="dialogVisible = true">创建</el-button>
                </div>
                <div v-for="item in this.tableData" style="margin-top:15px;">
                    <el-card shadow="hover">
                        <el-row  class="boxCard">
                            <div class="left" v-if="item.channelType == 1">三态</div>
                            <div class="left" v-if="item.channelType == 2">云途</div>
                            <div class="left" v-if="item.channelType == 3">燕文</div>
                            <div class="left" v-if="item.channelType == 5">辰达通</div>
                            <div class="center">
                                <div class="TheAPI">API用户名:{{item.userId}}</div>
                                <div class="TheAPI">API Token:{{item.token}}</div>
                                <div class="TheAPI" v-if="item.appkey">API Key:{{item.appkey}}</div>
                            </div>
                            <div class="rights">
                                <el-button type="danger" style="float: right;" @click="del(item.id)">删除</el-button>
                            </div>
                        </el-row>
                    </el-card>
                </div>
            </el-card>
        </div>

        
        <el-dialog title="修改企业信息" :visible.sync="dialogTableVisible">
            <el-form>
                <el-form-item label="企业简称" label-width="100px">
                    <el-input v-model="companyInfo.companyFullName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="企业地址" label-width="100px">
                    <el-input v-model="companyInfo.companyAddress" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" label-width="100px">
                    <el-input v-model="companyInfo.telephone" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogTableVisible = false">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="添加物流API" :visible.sync="dialogVisible" width="30%" top="30vh">
        <el-form label-width="116px" label-position="left">
            <el-form-item label="选择物流商：">
                <el-radio-group v-model="radio" size="mini" @change="radioChange">
                    <el-radio-button label="1">三态</el-radio-button>
                    <el-radio-button label="2">云途</el-radio-button>
                    <el-radio-button label="3">燕文</el-radio-button>
                    <el-radio-button label="5">辰达通</el-radio-button>
                </el-radio-group>
            </el-form-item>

            <div>
                <el-form-item :label="userIdName+'：'">
                    <el-input style="width:80%;" v-model="userId"></el-input>
                </el-form-item>
                <el-form-item :label="tokenName+'：'" v-if="this.radio == 1||this.radio == 3||this.radio == 5">
                    <el-input style="width:80%;" v-model="token"></el-input>
                </el-form-item>
                <el-form-item label="API Key：" v-if="this.radio == 1||this.radio == 2">
                    <el-input style="width:80%;" v-model="appkey"></el-input>
                </el-form-item>
            </div>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="Create">确 定</el-button>
        </span>
        </el-dialog>
        <!-- <div class="Jurisdictions-content">公司主页</div>
        <div class="Jurisdictions-logo">
            <div class="Jurisdictions-logo-content">企业logo</div>
            <img src="" alt="">
        </div>
        <div class="Jurisdictions-content">
            <span>企业全称：海逊教学专用 </span>
        </div>
        <div class="Jurisdictions-content">
            <span>企业简称：CS</span>
        </div>
        <div class="Jurisdictions-content">
            <span>企业地址：山西省太原市小店区坞城路</span>
            <span class="Jurisdictions-content-span">修改</span>
        </div>
        <div class="Jurisdictions-content">
            <span>联系电话：12345678910</span>
            <span class="Jurisdictions-content-span">修改</span>
        </div>
         <div class="Jurisdictions-content">
            <span>企业成员：9人</span>
        </div>
         <div class="Jurisdictions-content">
            <span>企业部门：3个部门</span>
        </div>
        <div class="Jurisdictions-content">
            <span>已使用/人数上限：6/12</span>
        </div>
        <div class="Jurisdictions-content">
            <span style="display: block;
                float: left;">公司余额：0元；可用余额0元；实际余额0元</span>
            <span class="Jurisdictions-content-bag">充值</span>
        </div>
        <div class="Jurisdictions-content">
            <span style="display: block;
                float: left;">ERP充值余额：0元</span>
            <span class="Jurisdictions-content-bag">充值</span>
        </div>
        <div class="Jurisdictions-content">
            <span>创建时间：2019-10-11 00.00.00</span>
        </div>-->
    </div>
    
</template>

<script>
import Axios from 'axios';
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
    name: "Jurisdictions",
    data() {
        return {
            action: Baseurl + "imageController/uploadImage",
            dialogTableVisible: false,
            companyInfo: {},
            formData: {},
            UserInfo: {},
            dialogVisible:false,
            radio:1,
            userIdName:"API用户名",
            tokenName:"API Token",
            userId:"",
            token:"",
            appkey:"",
            tableData:[]
        };
    },
    mounted() {},
    created() {
        this.UserInfo = JSON.parse(localStorage.getItem("role"));
        this.getCompanyInfo();
        this.APIList();
    },
    computed: {
        myHeader(){
            return {
                "token":window.localStorage.getItem('token')
            }
        }
    },
    methods: {

        onerror(err){
            console.log(err)
        },
       
        // edit() {
        //     this.dialogTableVisible = true;
        // },
        APIList(){
            var obj = {
                companyId:this.UserInfo.company_id
            }
            ajaxPost(Baseurl + "channelSecretController/getChannelSecretListByCompanyId", obj).then(res => {
                if (res.data.code === 200) {
                    this.tableData = res.data.data
                }
            });
        },
        handleAvatarSuccess(response, file, fileList) {
            const { code, data } = response;
            if (code === 200) {
                this.companyInfo.logo = data;
                this.uploadCompanyLogo();
            }
        },
        uploadCompanyLogo() {
            const API = Baseurl + "companyController/updateCompanyLogo";
            const paramsData = {
                id: this.UserInfo.company_id,
                logo: this.companyInfo.logo,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code !== 200) {
                    this.companyInfo.logo = "";
                    this.$message.error("上传失败，请重试！");
                }
            });
        },
        getCompanyInfo() {
            const API = Baseurl + "companyController/selectCompanyByCompanyId";
            const paramsData = {
                id: this.UserInfo.company_id,
                type: this.UserInfo.type,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.companyInfo = data;
                    // console.log(this.companyInfo);
                }
            });
        },
        immediately(){
            this.$router.push({
                name:"costReconciliation"
            })
        },
        Create(){
            if(this.userId == ""){
                this.$message.error("请输入"+this.userIdName+"")
            }else if(this.radio != 2&&this.token == ""){
                this.$message.error("请输入"+this.tokenName+"")
            }else if(this.radio == 2 && this.appkey === ""){
                this.$message.error("请输入秘钥")
            }else if(this.radio == 1 && this.appkey == ""){
                this.$message.error("请输入API Key")
            }else{
                var obj = {
                    userId:this.userId,
                    token:this.token,
                    appkey:this.appkey,
                    channelType:this.radio,
                    companyId:this.UserInfo.company_id
                }
                ajaxPost(Baseurl + "channelSecretController/insertChannelSecret", obj).then(res => {
                    if (res.data.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '创建成功!'
                        });
                        this.APIList()
                    }else{
                        this.$message.error(res.data.data)
                    }
                    this.userId = ""
                    this.token = ""
                    this.appkey = ""
                    this.radio = 1
                    this.dialogVisible = false
                });
            }
        },
        cancel(){
            this.userId = ""
            this.token = ""
            this.appkey = ""
            this.dialogVisible = false
        },
        radioChange(){
            if(this.radio == 1){
                this.userIdName = "API用户名"
                this.tokenName = "API Token"
            }else if(this.radio == 2){
                this.userIdName = "客户代码"
                this.tokenName = "秘钥"
            }else if(this.radio == 3){
                this.userIdName = "客户ID"
                this.tokenName = "ApiToken"
                this.appkey = ""
            }else if(this.radio == 5){
                this.userIdName = "客户编码"
                this.tokenName = "验证码(token)"
                this.appkey = ""
            }
        },
        del(val){
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var obj = {
                    id:val
                }
                ajaxPost(Baseurl + "channelSecretController/deleteChannelSecret", obj).then(res => {
                    if (res.data.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.APIList();
                    }else{
                        this.$message.error(res.data.data)
                    }
                });
            })
        }
    },
};
</script>
<style lang="scss" scoped>
/deep/ {
    .el-dialog__body{
        padding: 30px 30px !important;
    }
}
</style>
<style lang="scss" scoped>
.analysis {
    .box{
        display: flex;
        justify-content: left;
        flex-wrap: wrap;
    }
    .el-dialog__body{
        padding: 30px 30px !important;
    }
    .boxCard{
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
    .left{
        width: 5%;
        border-right: 1px solid #EBEEF5;
        writing-mode: tb-rl;
        font-weight: bold;
        font-size: 30px;
        line-height: 95px;
        text-align: center;
    }
    .center{
        width: 85%;
        padding-left: 15px;
        line-height: 30px;
    }
    .TheAPI{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .rights{
        width: 10%;
    }
    .analysisframe {
        width: 30%;
        height: 150px;
        overflow: hidden;
        margin-right: 1%;
        margin: 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        position: relative;
        .addcompany {
            color: #f56c6c;
            font-weight: 600;
            position: absolute;
            right: 20px;
            bottom: 15px;
            font-size: 18px;
            cursor: pointer;
        }
        .analysisimg {
            width: 100px;
            height: 100%;
            background: #eae5e5;
            float: left;
            .ifon {
                display: block;
                width: 100px;
                font-size: 75px;
                text-align: center;
                margin-top: 10px;
            }
            span {
                display: block;
                width: 100px;
                color: #5f5e5e;
                text-align: center;
                font-size: 16px;
            }
        }
        .analysiscontent {
            width: calc(100% - 110px);
            float: right;
            .iedit {
                float: right;
                font-size: 30px;
                padding: 10px;
            }
            .responsibilities span{
                display: inline!important;
            }
            span {
                display: block;
                width: 100%;
                line-height: 35px;
            }
        }
    }
    .Jurisdictions-logo {
        overflow: hidden;
        .Jurisdictions-logo-content {
            line-height: 40px;
            float: left;
        }
        img {
            width: 90px;
            height: 90px;
        }
    }
    .Jurisdictions-content {
        line-height: 40px;
        width: 100%;
        overflow: hidden;
        .Jurisdictions-content-span {
            margin-left: 40px;
            color: #0d6ec3;
        }
        .Jurisdictions-content-bag {
            display: block;
            float: left;
            width: 100px;
            border-radius: 5px;
            margin-left: 50px;
            line-height: 25px;
            color: #fff;
            margin-top: 7.5px;
            text-align: center;
            background: #2698e8;
        }
    }
    .Customer{
        height: 150px;
        display: flex;
        justify-content: left;
    }
    .right{
        margin-right:10px;
        display: flex;
        align-items: center;
    }
    .clickView:hover{
        color: #409EFF;
        cursor: pointer;
    }
}
</style>
